import React from "react";

export default function SslSecurePayment() {
    return (
        <p className="s14">
            <span className="strong overlay-c"><i className="icon-lock"></i> SSL secure payment</span>
            Your information is protected by 256-bit SSL encryption
        </p>
    )
}